import React, {FC} from 'react';

import {computeCallToActionFromQueryParams} from './visitorCommon';
import {VisitorViewerSidebarContentCta} from './visitorViewerSidebarContentCta';
import {VisitorViewerSidebarContentWelcome} from './visitorViewerSidebarContentWelcome';

/*
 * Component.
 */

export const VisitorViewerSidebarContentV3: FC = () => {
  const callToAction = computeCallToActionFromQueryParams();

  return (
    <>
      <VisitorViewerSidebarContentWelcome />
      <VisitorViewerSidebarContentCta cta={callToAction} />
    </>
  );
};
